import { __awaiter, __generator, __values } from "tslib";
import { logError } from '@office-start/telemetry-service';
export var AppId = '0ec893e0-5785-4de6-99da-4ed124e5296c';
export var KnownAuthorities;
(function (KnownAuthorities) {
    KnownAuthorities["MSA"] = "consumers";
    KnownAuthorities["AAD"] = "organizations";
})(KnownAuthorities || (KnownAuthorities = {}));
var LocalSettingsKeys;
(function (LocalSettingsKeys) {
    LocalSettingsKeys["CurrentUserProviderId"] = "CurrentUserProviderId";
    LocalSettingsKeys["CurrentAuthority"] = "CurrentAuthority";
    LocalSettingsKeys["CurrentAccountId"] = "CurrentAccountId";
})(LocalSettingsKeys || (LocalSettingsKeys = {}));
var ProviderIds;
(function (ProviderIds) {
    ProviderIds["Local"] = "https://login.windows.local";
    ProviderIds["MsaAad"] = "https://login.microsoft.com";
})(ProviderIds || (ProviderIds = {}));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isWebView = window.chrome && window.chrome.webview;
var WebCoreManager = (function () {
    var _a, _b, _c, _d, _e;
    return isWebView
        ? (_e = (_d = (_c = (_b = (_a = window.Windows) === null || _a === void 0 ? void 0 : _a.Security) === null || _b === void 0 ? void 0 : _b.Authentication) === null || _c === void 0 ? void 0 : _c.Web) === null || _d === void 0 ? void 0 : _d.Core) === null || _e === void 0 ? void 0 : _e.WebAuthenticationCoreManager
        : null;
})();
var LocalSettings = (function () {
    var _a, _b, _c, _d;
    return isWebView
        ? (_d = (_c = (_b = (_a = window.Windows) === null || _a === void 0 ? void 0 : _a.Storage) === null || _b === void 0 ? void 0 : _b.ApplicationData) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.localSettings.values
        : null;
})();
export var isWindowsAuthAvailable = (function () {
    return !!(WebCoreManager && LocalSettings);
})();
export function getWamAccessToken(resource, user) {
    return __awaiter(this, void 0, void 0, function () {
        var provider, account;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isWindowsAuthAvailable) {
                        return [2 /*return*/, Promise.reject('WebCoreManager or LocalSettings not defined')];
                    }
                    return [4 /*yield*/, WindowsTokens.getAccountProvider(user)];
                case 1:
                    provider = _a.sent();
                    if (!provider) {
                        return [2 /*return*/, Promise.reject('unable to get WebAccountProvider')];
                    }
                    return [4 /*yield*/, WindowsTokens.getWebAccount(provider)];
                case 2:
                    account = _a.sent();
                    if (!account || !isUsersWebAccount(user, account)) {
                        return [2 /*return*/, Promise.reject("unable to get WebAccount with provider: ".concat(provider.id))];
                    }
                    return [2 /*return*/, WindowsTokens.getToken(provider, account, resource)];
            }
        });
    });
}
var WindowsTokens = /** @class */ (function () {
    function WindowsTokens() {
    }
    WindowsTokens.saveProvider = function (provider) {
        if (!LocalSettings)
            return;
        if (!provider.id || !provider.authority) {
            logError({
                eventName: 'HWA_Auth',
                errorType: 'Data_Error',
                message: 'Provider missing id or authority',
            });
        }
        LocalSettings.insert(LocalSettingsKeys.CurrentUserProviderId, provider.id);
        LocalSettings.insert(LocalSettingsKeys.CurrentAuthority, provider.authority);
    };
    WindowsTokens.saveWebAccount = function (account) {
        if (!LocalSettings)
            return;
        WindowsTokens.currentUserAccount = account;
        var provider = account.webAccountProvider;
        if (account && !provider) {
            logError({
                eventName: 'HWA_Auth',
                errorType: 'Data_Error',
                message: 'Account missing provider',
            });
            return;
        }
        account
            ? LocalSettings.insert(LocalSettingsKeys.CurrentAccountId, account.id)
            : LocalSettings.remove(LocalSettingsKeys.CurrentAccountId);
        WindowsTokens.saveProvider(provider);
    };
    WindowsTokens.createWebTokenRequest = function (provider, resource) {
        var isCommercial = provider.authority === KnownAuthorities.AAD;
        var scope = isCommercial ? 'openid' : resource || 'wl.basic';
        var clientId = isCommercial ? AppId : 'none';
        var request = new Windows.Security.Authentication.Web.Core.WebTokenRequest(provider, scope, clientId);
        if (isCommercial) {
            request.properties.insert('resource', resource ? resource : '4345a7b9-9a63-4910-a426-35363201d503');
        }
        if (!request) {
            logError({
                eventName: 'HWA_Auth',
                errorType: 'Request_Failed',
                message: 'Failed to create WebTokenRequest',
            });
        }
        return request;
    };
    WindowsTokens.findAccount = function (provider, id) {
        return __awaiter(this, void 0, void 0, function () {
            var account, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!WebCoreManager || !provider || !(id === null || id === void 0 ? void 0 : id.length))
                            return [2 /*return*/, account];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, WebCoreManager.findAccountAsync(provider, id)];
                    case 2:
                        account = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, account];
                }
            });
        });
    };
    WindowsTokens.isUsersAccountProvider = function (provider, user) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var account, result, _f, _g, account_1;
            var e_1, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!WebCoreManager || !provider || !((_a = user === null || user === void 0 ? void 0 : user.profile) === null || _a === void 0 ? void 0 : _a.oid))
                            return [2 /*return*/];
                        return [4 /*yield*/, WindowsTokens.findAccount(provider, user.profile.oid)];
                    case 1:
                        account = _j.sent();
                        if (account)
                            return [2 /*return*/, account];
                        // Get all the accounts for the provider and check for the matching 'OID' property
                        // on the account but if the findAllAccountsAsync method isn't supported
                        // there's nothing more that can be done
                        if (!WebCoreManager.findAllAccountsAsync ||
                            !((_e = (_d = (_c = (_b = Windows.Foundation) === null || _b === void 0 ? void 0 : _b.Metadata) === null || _c === void 0 ? void 0 : _c.ApiInformation) === null || _d === void 0 ? void 0 : _d.isMethodPresent) === null || _e === void 0 ? void 0 : _e.call(_d, 'Windows.Security.Authentication.Web.Core.WebAuthenticationCoreManager', 'FindAllAccountsAsync'))) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, WebCoreManager.findAllAccountsAsync(provider, AppId)];
                    case 2:
                        result = _j.sent();
                        try {
                            for (_f = __values(result.accounts), _g = _f.next(); !_g.done; _g = _f.next()) {
                                account_1 = _g.value;
                                if (isUsersWebAccount(user, account_1))
                                    return [2 /*return*/, account_1];
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_h = _f.return)) _h.call(_f);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    WindowsTokens.getAccountProviderForId = function (providerId, authority) {
        if (providerId === void 0) { providerId = ProviderIds.Local; }
        if (authority === void 0) { authority = null; }
        return __awaiter(this, void 0, void 0, function () {
            var provider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!WebCoreManager)
                            return [2 /*return*/];
                        return [4 /*yield*/, (authority
                                ? WebCoreManager.findAccountProviderAsync(providerId, authority)
                                : WebCoreManager.findAccountProviderAsync(providerId))];
                    case 1:
                        provider = _a.sent();
                        if (!((provider === null || provider === void 0 ? void 0 : provider.id) === ProviderIds.Local)) return [3 /*break*/, 3];
                        return [4 /*yield*/, (WebCoreManager === null || WebCoreManager === void 0 ? void 0 : WebCoreManager.findAccountProviderAsync(ProviderIds.MsaAad, provider.authority))];
                    case 2:
                        provider = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, provider];
                }
            });
        });
    };
    WindowsTokens.getAccountProvider = function (user) {
        var _a, _b;
        if (user === void 0) { user = null; }
        return __awaiter(this, void 0, void 0, function () {
            var authority, providerId, authorities, provider, account;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!WebCoreManager)
                            return [2 /*return*/];
                        // if the cached webAccount matches the user return the associated provider
                        if (((_a = WindowsTokens.currentUserAccount) === null || _a === void 0 ? void 0 : _a.webAccountProvider) &&
                            isUsersWebAccount(user, WindowsTokens.currentUserAccount)) {
                            return [2 /*return*/, (_b = WindowsTokens.currentUserAccount) === null || _b === void 0 ? void 0 : _b.webAccountProvider];
                        }
                        authority = LocalSettings === null || LocalSettings === void 0 ? void 0 : LocalSettings[LocalSettingsKeys.CurrentAuthority];
                        providerId = (LocalSettings === null || LocalSettings === void 0 ? void 0 : LocalSettings[LocalSettingsKeys.CurrentUserProviderId]) ||
                            ProviderIds.Local;
                        authorities = [KnownAuthorities.AAD, KnownAuthorities.MSA];
                        _c.label = 1;
                    case 1:
                        if (!((authority === null || authority === void 0 ? void 0 : authority.length) || authorities.length)) return [3 /*break*/, 4];
                        if (authority === null || authority === void 0 ? void 0 : authority.length) {
                            providerId = ProviderIds.MsaAad;
                        }
                        return [4 /*yield*/, WindowsTokens.getAccountProviderForId(providerId, authority)];
                    case 2:
                        provider = _c.sent();
                        // If not trying to match a provider with a user then we're done
                        if (provider && !user)
                            return [2 /*return*/, provider];
                        return [4 /*yield*/, WindowsTokens.isUsersAccountProvider(provider, user)];
                    case 3:
                        account = _c.sent();
                        if (account) {
                            WindowsTokens.saveWebAccount(account);
                            return [2 /*return*/, provider];
                        }
                        if (provider) {
                            authorities = authorities.filter(function (a) { return a != (provider === null || provider === void 0 ? void 0 : provider.authority); });
                        }
                        authority = authorities.shift();
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WindowsTokens.getWebAccount = function (provider, accountId) {
        var _a, _b, _c, _d;
        if (accountId === void 0) { accountId = null; }
        return __awaiter(this, void 0, void 0, function () {
            var account, tokenRequest, tokenResult;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!WebCoreManager)
                            return [2 /*return*/];
                        if (!accountId) {
                            accountId = LocalSettings === null || LocalSettings === void 0 ? void 0 : LocalSettings[LocalSettingsKeys.CurrentAccountId];
                        }
                        // if the cached webAccount matches the user return it
                        if (((_a = WindowsTokens.currentUserAccount) === null || _a === void 0 ? void 0 : _a.id) === accountId)
                            return [2 /*return*/, WindowsTokens.currentUserAccount];
                        if (!provider) {
                            return [2 /*return*/];
                        }
                        if (!accountId) return [3 /*break*/, 2];
                        return [4 /*yield*/, WindowsTokens.findAccount(provider, accountId)];
                    case 1:
                        account = _e.sent();
                        if (account) {
                            return [2 /*return*/, account];
                        }
                        _e.label = 2;
                    case 2:
                        tokenRequest = WindowsTokens.createWebTokenRequest(provider);
                        return [4 /*yield*/, WebCoreManager.getTokenSilentlyAsync(tokenRequest)];
                    case 3:
                        tokenResult = _e.sent();
                        if ((tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.responseStatus) !==
                            Windows.Security.Authentication.Web.Core.WebTokenRequestStatus
                                .success) {
                            logError({
                                eventName: 'HWA_Auth',
                                errorType: 'Authentication_Failed',
                                message: ((_b = tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.responseError) === null || _b === void 0 ? void 0 : _b.errorMessage) ||
                                    ((_c = tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.responseStatus) === null || _c === void 0 ? void 0 : _c.toString()),
                            });
                            return [2 /*return*/, account];
                        }
                        account = (_d = tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.responseData) === null || _d === void 0 ? void 0 : _d[0].webAccount;
                        WindowsTokens.saveWebAccount(account);
                        return [2 /*return*/, account];
                }
            });
        });
    };
    WindowsTokens.getToken = function (provider, account, resource) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var tokenRequest, result, message;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tokenRequest = WindowsTokens.createWebTokenRequest(provider, resource);
                        return [4 /*yield*/, (account
                                ? WebCoreManager === null || WebCoreManager === void 0 ? void 0 : WebCoreManager.getTokenSilentlyAsync(tokenRequest, account)
                                : WebCoreManager === null || WebCoreManager === void 0 ? void 0 : WebCoreManager.getTokenSilentlyAsync(tokenRequest))];
                    case 1:
                        result = _b.sent();
                        if ((result === null || result === void 0 ? void 0 : result.responseStatus) !==
                            Windows.Security.Authentication.Web.Core.WebTokenRequestStatus
                                .success) {
                            message = "failed to get auth token: ".concat((_a = result === null || result === void 0 ? void 0 : result.responseError) !== null && _a !== void 0 ? _a : 'null result');
                            console.warn(message);
                            return [2 /*return*/, Promise.reject(message)];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return WindowsTokens;
}());
function isUsersWebAccount(user, account) {
    var _a, _b;
    return user && account && ((_a = account.properties) === null || _a === void 0 ? void 0 : _a['OID']) === ((_b = user.profile) === null || _b === void 0 ? void 0 : _b.oid);
}
export function getExpiry(properties, isCommercial) {
    var expiry = parseInt(properties === null || properties === void 0 ? void 0 : properties.lookup('exp')) * 1000; // Only available on JWT tokens.
    if (expiry || !isCommercial) {
        return expiry;
    }
    return new Date().getTime() + 3600000; // 1 hour in the future
}
//# sourceMappingURL=WindowsTokens.js.map